import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import coffeeIcon from "../../assets/images/coffee.png";
import osIcon from "../../assets/images/os.png";
import terminalIcon from "../../assets/images/terminal.png";
import { Context } from "../../context";

import classes from "./Terminal.module.css";

const OpenTerminal = () => {
  const { terminal, setTerminal, setViewMode } = useContext(Context);
  const savedLang = localStorage.getItem("language");

  return (
    <>
      {!terminal && (
        <>
          <div className={classes.openTerminal}>
            <NavLink
              to="/experiments"
              onClick={() => {
                setViewMode("terminal2d");
                setTerminal(true);
              }}
              className="nav-link nav-link-mobile smooth-scroll"
            >
              <div className={classes.openTerminalRow}>
                <img
                  src={terminalIcon}
                  className={classes.terminalIcon}
                  alt="terminalIcon"
                />
                <div className={classes.openTerminalText}>
                  {savedLang === "it" ? (
                    <>Apri terminale</>
                  ) : (
                    <>Open terminal</>
                  )}
                </div>
              </div>
            </NavLink>

            <NavLink
              to="/experiments"
              onClick={() => {
                setViewMode("os2d");
                setTerminal(true);
              }}
              className="nav-link nav-link-mobile smooth-scroll"
            >
              <div className={classes.openTerminalRow}>
                <img
                  src={osIcon}
                  className={classes.terminalIcon}
                  alt="terminalIcon"
                />
                <div className={classes.openTerminalText}>
                  {savedLang === "it" ? <>Apri Os</> : <>Launch Os</>}
                </div>
              </div>
            </NavLink>

            <NavLink
              to="/experiments"
              onClick={() => {
                setViewMode("coinop2d");
                setTerminal(true);
              }}
              className="nav-link nav-link-mobile smooth-scroll"
            >
              <div className={classes.openTerminalRow}>
                <img
                  src={coffeeIcon}
                  className={classes.coffeeIcon}
                  alt="coffeeIcon"
                />
                <div className={classes.openTerminalText}>
                  {savedLang === "it" ? <>Pausa caffè</> : <>Coffee break</>}
                </div>
              </div>
            </NavLink>
          </div>
        </>
      )}
    </>
  );
};

export default OpenTerminal;
